<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="nome" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nome</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd_ibge" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código IBGE</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0">
                        <multiselect v-model="uf_id"
                        :options="optionsUf"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="UF"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      nome: "",
      cd_ibge: "",
      optionsLivStatus: [],
      status: [],
      optionsUf: [],
      uf_id: [],
      data_filter: []
    };
  },
  mounted() {
    this.getStatus();
    this.getUf();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        nome: this.nome,
        cd_ibge: this.cd_ibge,
        status: this.status,
        uf_id: this.uf_id
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.nome = ""; // clear the text in text input
      this.cd_ibge = "";
      this.status = "";
      this.uf_id = "";
      this.$events.fire("filter-reset");
    },
    getUf() {
      this.helpForm
        .get("/api/uf/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach(obj => {
            this.optionsUf.push({ label: obj.nome, value: obj.uf_id });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },

    getStatus() {
      this.helpForm.params = { tabela: "municipio", coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, false, false);
        });
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      }
    }
  }
};
</script>
